import { Link, useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../../components/common/SideBarWrapper";
import Navbar from "../../../layout/Navbar";
import { useEffect, useState } from "react";
import { baseURL } from "../../../utils/misc";
import useAuth from "../../../hooks/useAuth";
import Footer from "../../../layout/Footer";
import SpoilageForm from "../../../components/SpoilageReports/SpoilageForm";
import ExportCustomForm from "../../../components/ExportCustomsRecords/ExportCustomForm";
import { toast } from "react-toastify";

const EditExportCustomRecord = () => {
    const { exportCustomId } = useParams();
    const [exportCustomRecord, setExportCustomRecord] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        // Fetch workflow process data when the component mounts
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };

            try {
                const response = await fetch(`${baseURL}/exportcustomsrecords/${exportCustomId}`, requestOptions);

                if (response.ok) {
                    const data = await response.json();
                    setExportCustomRecord(data);
                } else {
                    console.error('Error fetching export custom record data');
                }
            } catch (error) {
                console.error('Error fetching export custom record data:', error);
            }
        };

        fetchData();
    }, [exportCustomId, navigate, user]);



    return (<>


        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item">{exportCustomRecord && exportCustomRecord && exportCustomRecord.code}</li>
                        <li className="breadcrumb-item">
                            <Link to={`/exportcustomsrecords/crop/${exportCustomRecord && exportCustomRecord && exportCustomRecord.cropId}`} >Export Custom Records</Link>
                        </li>
                        <li className="breadcrumb-item active">Edit</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    <ExportCustomForm crop={exportCustomRecord && exportCustomRecord.crop} exportCustomRecord={exportCustomRecord && exportCustomRecord}/>
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </>);
}

export default EditExportCustomRecord;